<template>
  <div class="complaint-section">
    <div class="complaint-section-top">
      <p class="complaint-section-title">
        <span>{{ this.label }}</span>
      </p>
    </div>
    <div class="complaint-section-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComplaintSection',
  props: {
    label: {
      type: String
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
  @import './index.less';
</style>
